module.exports = __webpack_public_path__ + "img/volume.163fa0a5.svg";